/* eslint-disable react/style-prop-object */
import { isEmpty } from 'lodash';
import type { ReactElement } from 'react';

import { BaseBlock } from '@/components/base-block';
import { Icon } from '@/components/icon';
import { StructuredText } from '@/components/structured-text';
import type { NoticeBlockType } from '@/lib/types';

const NoticeBlock = ({ title, content, anchor }: NoticeBlockType): ReactElement => {
  return (
    <BaseBlock className="rich-text" width="Narrow" anchor={anchor} hasContentPadding={false}>
      <div className="notice-container p-5">
        {!isEmpty(title) && (
          <h3 className="notice-title">
            <Icon name="info-circle" /> {title}
          </h3>
        )}
        {!isEmpty(content) && <StructuredText data={content} />}
        <div>&nbsp;</div>
      </div>
    </BaseBlock>
  );
};

export { NoticeBlock };
